import ExceptionBase from "@/dto/exceptions/exceptionBase";
export default class OperationFailedException extends ExceptionBase {
  constructor(data) {
    super(data);
  }
}
